import { FolderPath } from "@/components/MoveToFolderModal/FolderPath";
import { useFoldersData } from "@/components/Registry/hooks/useFoldersData";
import FolderGrid from "@/components/Registry/FolderGrid";
import TemplateGrid from "@/components/Registry/TemplateGrid";
import { FolderNode } from "@/components/Registry/utils";
import { Folder } from "@/types/folders";
import { PromptRegistry } from "@/types/prompt-registry";
import { FolderIcon } from "@heroicons/react/outline";

const Folders = ({
  searchQuery,
  templates,
  folders,
  folderPath,
  selectedTags,
}: {
  searchQuery: string;
  templates: PromptRegistry[];
  folders: Folder[];
  folderPath: string[];
  selectedTags: string[];
}) => {
  const { filteredFolders, foldersWithTemplates } = useFoldersData({
    templates,
    folders,
    folderPath,
  });

  if (!folders.length) return null;

  return (
    <>
      {searchQuery === "" && !selectedTags.length ? (
        <>
          <div className="mt-10">Folders</div>
          <div className="mt-4 flex-1">
            <FolderGrid folders={filteredFolders} />
          </div>
        </>
      ) : (
        foldersWithTemplates.map((folder) => (
          <div key={folder.id}>
            <FolderHeader folder={folder} />
            <div className="mt-4 flex-1">
              <TemplateGrid templates={folder.templates} />
            </div>
          </div>
        ))
      )}
    </>
  );
};

const FolderHeader = ({ folder }: { folder: FolderNode }) => (
  <div className="mt-10 flex items-center gap-2">
    <FolderIcon className="h-6 w-6 text-gray-400" />
    <strong>Folder:</strong> <FolderPath topLevelFolder={folder.name} />
  </div>
);

export default Folders;
